'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import security from 'components/Auth/Security';
import { isAuthenticated } from 'services/identity.service';

const WithAuth = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname();
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const isAuth = isAuthenticated();
      const isProtectedRoute = security.isProtected(pathname);

      if (!isAuth && isProtectedRoute) {
        setAuthorized(false);
        router.replace('/login');
      } else if (isAuth && pathname === '/login') {
        router.replace('/');
      } else {
        setAuthorized(true);
      }
    };

    checkAuth();
  }, [pathname, router]);

  if (!authorized && security.isProtected(pathname)) {
    return null;
  }

  return <>{children}</>;
};

export default WithAuth;
